export default {
  title: 'Ostoskori',
  buttons: {
    login_to_checkout: 'Kirjaudu sisään kassalle',
    checkout: 'Kassalle',
  },
  go_to_menu: 'Siirry ruokalistaan',
  toasts: {
    cashback_points_removed: 'Pistesaldosi on muuttunut, joten poistimme pisteet tästä tilauksesta.',
  },
};
